module.exports = __webpack_public_path__ + "static/img/a11.bb15a413.jpg";